import { PlaceholderPage } from './PlaceholderPage';

export const SecurityRolesPage = () => <PlaceholderPage title="Security Roles" />;
